import React, { FC, useMemo, useRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import { Column, FilterRow, Pager, Paging } from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { useAuth } from 'context/auth';
import { TreeList } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { FactoryDetail } from 'bus/factory/types';

import { CreateEditModal, DeleteModal } from './components';
import { TypeModal } from './types';

const Factory: FC = () => {
  const factoryDataStore: any = useMemo(() => {
    return $createStore('/v1/factory/', 'id');
  }, []);

  const refGrid = useRef<TreeList | null>(null);
  const { getClaims }: any = useAuth();
  const [visibleEditCreateModal, setVisibleEditCreateModal] = useState(false);
  const [selectFactory, setSelectFactory] = useState<FactoryDetail | null>(null);
  const [modalType, setModalType] = useState<TypeModal>(TypeModal.ADD);

  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);

  const refreshGrid = () => refGrid.current?.instance.refresh();

  const hasPermission = getClaims(['CanEditFactory']);

  return (
    <div className="container-dev">
      <AppLayoutTop title="Заводы">
        <ClaimsProvider claimsBlock={['CanEditFactory']}>
          <Button
            width={120}
            text="Создать"
            type="default"
            onClick={() => {
              setVisibleEditCreateModal(true);
              setModalType(TypeModal.ADD);
            }}
          />
        </ClaimsProvider>
      </AppLayoutTop>

      <CreateEditModal
        changeVisible={(visible) => {
          if (!visible) setSelectFactory(null);
          setVisibleEditCreateModal(visible);
        }}
        factory={selectFactory}
        refresh={refreshGrid}
        visible={visibleEditCreateModal}
        type={modalType}
      />

      <DeleteModal
        changeVisible={(visible) => {
          setVisibleDeleteModal(visible);
        }}
        id={selectFactory?.id!}
        refresh={refreshGrid}
        visible={visibleDeleteModal}
      />

      <AppCard>
        <TreeList
          dataSource={factoryDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={refGrid}
          autoExpandAll
        >
          <FilterRow visible={true} />
          <Column dataField="name" caption="Наименование" sortOrder="asc" />
          <Column dataField="comment" caption="Комментарий" width={200} visible={false} />
          <Column
            dataField="actions"
            caption=""
            width={120}
            cellRender={(data) => (
              <>
                {!data.data.parentId && (
                  <Button
                    icon="add"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setSelectFactory(data.data);
                      setVisibleEditCreateModal(true);
                      setModalType(TypeModal.ADD_PARRENT);
                    }}
                    disabled={!hasPermission}
                  />
                )}
                <ClaimsProvider claimsBlock={['CanEditFactory']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setSelectFactory(data.data);
                      setVisibleEditCreateModal(true);
                      setModalType(TypeModal.EDIT);
                    }}
                    disabled={!hasPermission}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteFactory']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    disabled={!hasPermission}
                    onClick={() => {
                      setSelectFactory(data.data);
                      setVisibleDeleteModal(true);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </TreeList>
      </AppCard>
    </div>
  );
};

export default Factory;
